import { MediaSequencer } from "../features/sequence/MediaSequencer";

export function MediaPage() {
    return <MediaSequencer />;
}
